// UserForgotpass.jsx
import React, { useState } from 'react';
import axios from 'axios';
import config from '../../config/config';
import styles from './UserForgotpass.module.css';

const UserForgotpass = () => {
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage('');
    setError('');

    try {
      const res = await axios.post(`${config.apiBaseUrl}/api/users/forgot-password`, { email });

      setMessage(res.data.message);
    } catch (err) {
      setError(err.response?.data?.message || 'Something went wrong');
    }
  };

 return (
  <div className={styles.container}>
    <h2 className={styles.title}>Forgot Password</h2>
    <form onSubmit={handleSubmit} className={styles.form}>
      <input
        type="email"
        className={styles.input}
        placeholder="Enter your registered email"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        required
      />
      <button type="submit" className={styles.button}>
        Send Reset Link
      </button>
    </form>
    {message && <p className={styles.message}>{message}</p>}
    {error && <p className={styles.error}>{error}</p>}
  </div>
);
};

export default UserForgotpass;
